import axios from 'axios';
import showError from 'utils/errorHandler';

class Api {
  constructor() {
    this.serverApi = process.env.REACT_APP_API_URL;
    this.client = axios.create({ baseURL: this.serverApi });
  }

  contract = async (jobId) => {
    try {
      const response = await this.client.get(`/api/customerDocuments/ld_contract/${jobId}/sign`);

      return response;
    } catch (error) {
      showError(error);
    }
  };

  insurance = async (job_id, insurance_option) => {
    try {
      const response = await this.client.post('api/customerDocuments/insuranceOption', {
        job_id,
        insurance_option,
      });

      return response;
    } catch (error) {
      showError(error);
    }
  };

  sign = async (job_id, sign, document) => {
    try {
      await this.client.post(`/api/customerDocuments/saveSign`, {
        job_id,
        sign,
        document,
      });
      return true;
    } catch (error) {
      showError(error);
    }
  };

  saveCostValuation = async (job_id, value) => {
    try {
      await this.client.post(`/api/customerDocuments/costValuationConfirmation`, {
        job_id,
        value,
      });
      return true;
    } catch (error) {
      showError(error);
    }
  };

  saveShipmentValuation = async (job_id, value) => {
    try {
      await this.client.post(`/api/customerDocuments/shipmentValuation`, {
        job_id,
        value,
      });
      return true;
    } catch (error) {
      showError(error);
    }
  };
}

export default new Api();
